const MainBackground = () => {
  return <div className={"mainBackground"}></div>;
};
export default MainBackground;
